// Thin wrapper around GTM's dataLayer so tracking calls read like semantic events
// instead of scattering raw dataLayer.push({...}) calls across components.

export function track(event, payload = {}) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...payload })
}

const SCROLL_THRESHOLDS = [50, 75, 90]

// Fires scroll_50 / scroll_75 / scroll_90 once each per page view, tagged with the variant.
export function trackScrollDepth(variant) {
  const fired = new Set()

  const handler = () => {
    const scrolled = window.scrollY + window.innerHeight
    const total = document.documentElement.scrollHeight
    if (total <= 0) return
    const percent = (scrolled / total) * 100

    SCROLL_THRESHOLDS.forEach((threshold) => {
      if (percent >= threshold && !fired.has(threshold)) {
        fired.add(threshold)
        track(`scroll_${threshold}`, { variant })
      }
    })
  }

  window.addEventListener('scroll', handler, { passive: true })
  return () => window.removeEventListener('scroll', handler)
}
